import { Component, Input, OnInit } from '@angular/core';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { Team } from 'app/library/team/models/team.model';

@Component({
    selector: 'app-active-days',
    templateUrl: './active-days.component.html',
    styleUrls: ['./active-days.component.scss'],
})
export class ActiveDaysComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    team: Team;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {}
}
